import { Outlet } from "react-router-dom";
import { AuthProvider } from "./contexts/auth-context";

export default function AppShell() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
} 